import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MainPage = () => {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem('userEmail');

  useEffect(() => {
    if (!userEmail) navigate('/');
  }, [userEmail, navigate]);

  if (!userEmail) return null;

  return (
    <div style={styles.container}>
      {/* Sign Out button (Top Right) */}
      <button
        onClick={() => {
          sessionStorage.removeItem('userEmail');
          navigate('/');
        }}
        style={styles.signOutButton}
      >
        Sign Out
      </button>

      {/* Main Content */}
      <div style={styles.content}>
        <h1 style={styles.heading}>Welcome to WebRTC</h1>
        
        <p style={styles.emailText}>Signed in as: {userEmail}</p>

        <div style={styles.buttonGroup}>
          <button onClick={() => navigate('/rosaa')} style={styles.button}>
            ROSA A
          </button>

          <button onClick={() => navigate('/rosar')} style={styles.button}>
            ROSA R
          </button>
          <button onClick={() => navigate('/rosaw')} style={styles.button}>
            ROSA W
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    padding: '20px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#ffffff',
    padding: '50px 60px',
    borderRadius: '15px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    fontSize: '40px',
    marginBottom: '10px',
    color: '#333',
  },
  subHeading: {
    fontSize: '24px',
    color: 'pink',
    marginBottom: '20px',
  },
  emailText: {
    marginBottom: '40px',
    fontSize: '18px',
    color: '#555',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  button: {
    padding: '15px 50px',
    fontSize: '20px',
    borderRadius: '10px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
    transition: 'background 0.3s ease, transform 0.2s ease',
  },
  signOutButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    padding: '10px 20px',
    fontSize: '16px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#dc3545',
    color: '#fff',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'background 0.3s ease',
  },
};

// Add hover effects using inline trick
styles.button[':hover'] = { backgroundColor: '#0056b3', transform: 'scale(1.03)' };
styles.signOutButton[':hover'] = { backgroundColor: '#c82333' };

export default MainPage;
